// extracted by mini-css-extract-plugin
export default {"hidden":"ContactForm_hidden__Wgtsn","title":"ContactForm_title__sH+Lb","form":"ContactForm_form__RN-jP"};